import React from "react";
import "./subjectBox.css";
const SubjectBox = ({ subname, sublogo, notStarted, complated }) => {


  return (
    <div className="py-1 px-3 text-center shadow-sm rounded-4 mb-1 subject_card_style">
      <div className="d-flex flex-column align-items-center mb-1">
        <img src={sublogo} alt={subname} style={{ height: "32px" }} />
        <h6
          className="mt-1 fw-bold text-brown mx-auto text-truncate poppins-semibold"
          title={subname}
          style={{
            maxWidth: "100%", // allows truncation to work
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            hover: "pointer",
            color: "#8D4B28",
          }}
        >
          {subname && subname?.length > 15
            ? subname?.slice(0, 20) + "…"
            : subname}
        </h6>
      </div>
      <div className="d-flex justify-evenly gap-2 border-top pt-2 text-muted small fw-semibold ">
        <div className=" d-flex flex-column ">
          <small className="text-sm poppins-semibold ">Pending</small>
          <small className="text-dark poppins-semibold">
            {notStarted === 0 ? notStarted : String(notStarted).padStart(2, "0")}
          </small>
        </div>
        <div className="border-r-2 border-black"></div>
        <div className=" d-flex flex-column">
          <small className="poppins-semibold">Completed</small>
          <small className="text-dark poppins-semibold">
            {complated === 0
              ? complated
              : String(complated).padStart(2, "0")}
          </small>
        </div>
      </div>
      {/* <div className={isMore ? "subject_heading subHover summery_card_subject d-flex" : "subject_heading  d-flex"}>
        <span>{props.subname}</span>
        <img src={props.sublogo} alt="" />
      </div>
      <div className="boxes_list ">
        <span>Not started •&nbsp; </span>
        <span>{props.notStarted}</span>
      </div>
      <div className="boxes_list  ">
        <span>Completed •&nbsp; </span>
        <span>{props.complated}</span>
      </div> */}
    </div>
  );
};

export default SubjectBox;
